export enum ShiftOfferStatus {
  PENDING = 'PENDING',
  FILLED = 'FILLED',
  CANCELED = 'CANCELED',
}

export enum ShiftOfferOrder {
  DISTANCE = 'DISTANCE',
  BEGINAT = 'BEGINAT',
  CREATEDAT = 'CREATEDAT',
}
